import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    width: '100%',
    padding: '16px'
  },
  subtitleText: {
    marginBottom: '16px'
  }
});
